(() => {
  const root = document.querySelector('[data-email-popup]');
  if (!root) return;

  const tab = document.querySelector('[data-email-popup-tab]');
  const form = root.querySelector('form');
  const emailInput = root.querySelector('input[type="email"]');
  const submit = root.querySelector('[data-email-popup-submit]');
  const errorEl = root.querySelector('[data-email-popup-error]');
  const designMode = root.hasAttribute('data-design-mode');

  // Per-visitor memory: 'dismissed' keeps the side tab, 'subscribed' hides everything
  const STATE_KEY = 'eriso-popup-state';
  const TAB_KEY = 'eriso-popup-tab-hidden';
  const read = (store, key) => { try { return store.getItem(key); } catch (e) { return null; } };
  const write = (store, key, value) => { try { store.setItem(key, value); } catch (e) {} };
  const state = () => read(localStorage, STATE_KEY);

  let lastFocus = null;

  function showTab() {
    if (!tab || designMode) return;
    if (state() === 'subscribed' || read(sessionStorage, TAB_KEY)) return;
    tab.hidden = false;
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    if (tab) tab.hidden = true;
    document.documentElement.classList.add('email-popup-open');
    requestAnimationFrame(() => root.classList.add('is-open'));
    const focusTarget = root.classList.contains('is-success')
      ? root.querySelector('[data-email-popup-copy]')
      : emailInput;
    if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 50);
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('email-popup-open');
    setTimeout(() => { root.hidden = true; }, 250);
    if (!designMode && state() !== 'subscribed') {
      write(localStorage, STATE_KEY, 'dismissed');
      showTab();
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function showSuccess() {
    root.classList.add('is-success');
    if (!designMode) write(localStorage, STATE_KEY, 'subscribed');
    if (tab) tab.hidden = true;
  }

  function showError(message) {
    errorEl.textContent = message;
  }

  root.querySelectorAll('[data-email-popup-close]').forEach((el) => el.addEventListener('click', close));
  document.querySelectorAll('[data-email-popup-open]').forEach((el) => el.addEventListener('click', open));

  const tabDismiss = document.querySelector('[data-email-popup-tab-dismiss]');
  if (tabDismiss) {
    tabDismiss.addEventListener('click', () => {
      write(sessionStorage, TAB_KEY, '1');
      tab.hidden = true;
    });
  }

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    // Keep keyboard focus inside the dialog
    const focusable = [...root.querySelectorAll('button, input, a[href]')].filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // Copy code
  const copyBtn = root.querySelector('[data-email-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      const code = root.querySelector('[data-email-popup-code]').textContent.trim();
      try {
        await navigator.clipboard.writeText(code);
        copyBtn.textContent = 'Copied';
      } catch (e) {
        const range = document.createRange();
        range.selectNodeContents(root.querySelector('[data-email-popup-code]'));
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        copyBtn.textContent = 'Selected';
      }
      setTimeout(() => { copyBtn.textContent = 'Copy'; }, 2000);
    });
  }

  // Sign up without leaving the page
  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!emailInput.value || !emailInput.checkValidity()) {
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }
      showError('');
      submit.disabled = true;
      const label = submit.textContent;
      submit.textContent = 'Signing up…';

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
        });
        // Shopify sometimes asks for a spam check — hand over to a normal submit
        if (response.url.includes('/challenge')) {
          form.submit();
          return;
        }
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const posted = response.url.includes('customer_posted=true') || doc.querySelector('[data-email-popup-posted]');
        const serverError = doc.querySelector('[data-email-popup-error]');

        if (posted) {
          showSuccess();
          const copy = root.querySelector('[data-email-popup-copy]');
          if (copy) copy.focus({ preventScroll: true });
        } else if (serverError && serverError.textContent.trim()) {
          showError(serverError.textContent.trim());
        } else {
          showError('Something went wrong. Please try again.');
        }
      } catch (e) {
        showError('Something went wrong. Please try again.');
      } finally {
        submit.disabled = false;
        submit.textContent = label;
      }
    });
  }

  // Theme editor: open while the section is selected
  if (designMode) {
    document.addEventListener('shopify:section:select', (event) => {
      if (root.closest('.shopify-section')?.id.includes(event.detail.sectionId)) open();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (root.closest('.shopify-section')?.id.includes(event.detail.sectionId)) close();
    });
    return;
  }

  // Returning after a no-JS signup (or a spam check)
  if (root.querySelector('[data-email-popup-posted]')) {
    showSuccess();
    open();
    return;
  }
  if (errorEl.textContent.trim()) {
    open();
    return;
  }

  const current = state();
  if (current === 'subscribed') return;
  if (current === 'dismissed') {
    showTab();
    return;
  }

  const delay = Math.max(0, Number(root.dataset.delay) || 6) * 1000;
  setTimeout(() => {
    if (state() || !root.hidden) return;
    open();
  }, delay);
})();
